import apiService from "services/api";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Col,
} from "reactstrap";
import { FormEntry } from "components";
import { useForm } from "react-hook-form";
import { useState } from "react";

const initialState = {
  username: "",
  password: "",
};

const getPostLoginRedirect = () => {
  const currentUrl = new URL(window.location.href);
  const params = currentUrl.searchParams;
  const redirect = params.get("redirect");
  const fallback = process.env.REACT_APP_BASE_URL || window.location.origin;

  if (!redirect) {
    params.delete("redirect");
    return currentUrl.href;
  }

  try {
    const destination = new URL(redirect, window.location.origin);
    return destination.origin === window.location.origin
      ? destination.href
      : fallback;
  } catch {
    return fallback;
  }
};

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: initialState,
    reValidateMode: "onSubmit",
    mode: "onSubmit",
  });
  const redirect = getPostLoginRedirect();

  const submitLogin = (formData) => {
    setLoading(true);
    apiService.auth
      .login(formData)
      .then(() => window.location.assign(redirect))
      .catch(() =>
        setError("password", { message: "Invalid login credentials" }),
      )
      .finally(() => setLoading(false));
  };

  return (
    <div className="justify-content-center min-vh-100 align-items-center d-flex">
      <Col sm={6} md={6}>
        <Card>
          <CardHeader>
            <CardTitle className="font-weight-bold display-4 mt-3 text-center">
              Genius Staff Dashboard
            </CardTitle>
            {/* <div className="font-weight-bold display-4 text-center">
              Genius Admin
            </div> */}
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleSubmit(submitLogin)} id="loginForm">
              <FormEntry
                register={register}
                formLabel="Username"
                placeholder="Account Username"
                error={errors.username}
                name="username"
                required={true}
              />

              <FormEntry
                register={register}
                type="password"
                formLabel="Password"
                placeholder="Account Password"
                error={errors.password}
                name="password"
                required={true}
              />
            </Form>
          </CardBody>
          <CardFooter className="text-center">
            <Button
              className="btn-fill"
              color="primary"
              type="submit"
              form="loginForm"
              disabled={loading}
            >
              Login
            </Button>
          </CardFooter>
        </Card>
      </Col>
    </div>
  );
};

export default LoginPage;
